let routerlist = [{
    path: '/',
    name: 'home',
    component: resolve => (require(['@/views/Home'], resolve)),
    redirect: '/home',
    children: [{
            path: '/home',
            name: '首页',
            component: resolve => (require(['@/components/Homepage/Homedetail.vue'], resolve)),
            iconClass: 'm-menu-icon icon1'
        },
        {
            path: '/about',
            name: '关于我们',
            redirect: '/company',
            component: resolve => (require(['@/components/Aboutus/About.vue'], resolve)),
            iconClass: 'm-menu-icon icon2',
            children: [{
                    path: '/company',
                    name: '公司简介'
                },
                {
                    path: '/team',
                    name: '公司团队'
                },
                {
                    path: '/culture',
                    name: '企业文化'
                },
                {
                    path: '/exhibition',
                    name: '公司展示'
                },
                {
                    path: '/partner',
                    name: '合作伙伴'
                },
                {
                    path: '/recruit',
                    name: '人才招聘'
                }
            ]
        },
        {
            path: '/product',
            name: '产品',
            component: resolve => (require(['@/components/Product/Product.vue'], resolve)),
            iconClass: 'm-menu-icon icon1',
            children: [{
                    path: '/industry',
                    name: 'Industry PCBA'
                },
                // {
                //   path: '/team',
                //   name: '成品'
                // },
                {
                    path: '/automotive',
                    name: 'Automotive PCBA'
                },
                {
                    path: '/network',
                    name: 'Network PCBA'
                },
                {
                    path: '/energy',
                    name: 'New Energy'
                },
                {
                    path: '/molding',
                    name: '注塑'
                }
            ]
        },
        {
            path: '/news',
            name: '新闻',
            component: resolve => (require(['@/components/News/News.vue'], resolve)),
            iconClass: 'm-menu-icon icon1'
        },
        {
            path: '/service',
            name: '服务',
            component: resolve => (require(['@/components/Service/Service.vue'], resolve)),
            iconClass: 'm-menu-icon icon1',
            children: [{
                    path: '/storage',
                    name: '智能仓储'
                },
                {
                    path: '/advantage',
                    name: '我们的优势'
                }
            ]
        },
        {
            path: '/contact',
            name: '联系我们',
            component: resolve => (require(['@/components/Contact/Contact.vue'], resolve)),
            iconClass: 'm-menu-icon icon4'
        },
        // {
        //   path: '/commodity',
        //   name: '芯片销售',
        //   component: resolve => (require(['@/components/Commodity/Commodity.vue'], resolve)),
        //   iconClass: 'm-menu-icon icon4'
        // }
    ]
}]
export default routerlist


// WEBPACK FOOTER //
// ./src/router/zh_index.js